import React from 'react';
import { MemberPartScopeTabs } from './MemberListSectionParts';
import MemberPeopleSections from './MemberPeopleSections';
import MemberModalArtistContent from './MemberModalArtistContent';

export default function MemberListModalContent({
  admins = [],
  onAdminClick,
  adminKeyResolver,
  formatAdminName,
  resolveAdminMembershipLabel,
  adminAvatarStyle,
  adminInitial,
  plannerMembers = [],
  showPlanner = false,
  onPlannerClick,
  avatarStyle,
  avatarInitial,
  responsibleEmptyText = '未設定',
  plannerEmptyText = '企画者が設定されていません',
  showPartScopeTabs = false,
  partScopeTabs = [],
  activePartScopeValue = 'all',
  onChangePartScope,
  partScopeKeyPrefix = 'member-scope',
  showArtistMembers = true,
  isGroupMode = false,
  groupArtistSections = [],
  decidedSections = [],
  undecidedList = [],
  isAllMemberPartScope = true,
  onArtistClick,
  artistEmptyText = '参加メンバーがいません',
  artistHiddenText = '参加メンバー決定後公開',
  groupShowMembership = false,
  groupShowBadges = false,
  groupIncludeCustomRoles = false,
  groupSectionTitleBuilder,
  renderGroupMemberTrailing,
  renderArtistMemberTrailing,
}) {
  return (
    <>
      <MemberPeopleSections
        admins={admins}
        onAdminClick={onAdminClick}
        adminKeyResolver={adminKeyResolver}
        formatAdminName={formatAdminName}
        resolveAdminMembershipLabel={resolveAdminMembershipLabel}
        adminAvatarStyle={adminAvatarStyle}
        adminInitial={adminInitial}
        plannerMembers={plannerMembers}
        showPlanner={showPlanner}
        onPlannerClick={onPlannerClick}
        avatarStyle={avatarStyle}
        avatarInitial={avatarInitial}
        sectionClassName="member-modal__section"
        responsibleSectionClassName="member-modal__section member-modal__responsible"
        plannerSectionClassName="member-modal__section member-modal__planner"
        titleClassName="member-modal__section-title"
        listClassName="member-modal__responsible-list"
        rowClassName="member-modal__responsible-row"
        avatarClassName="member-modal__responsible-avatar"
        textClassName="member-modal__responsible-text"
        nameClassName="member-modal__responsible-name"
        metaClassName="member-modal__responsible-meta"
        membershipClassName="member-modal__event-membership"
        emptyClassName="member-modal__empty"
        responsibleEmptyText={responsibleEmptyText}
        plannerEmptyText={plannerEmptyText}
      />

      {showPartScopeTabs ? (
        <MemberPartScopeTabs
          tabs={partScopeTabs}
          activeValue={activePartScopeValue}
          onChange={onChangePartScope}
          wrapperClassName="member-modal__event-part-tabs"
          tabClassName="member-modal__event-part-tab"
          keyPrefix={partScopeKeyPrefix}
          ariaLabel="出演者の公演切り替え"
        />
      ) : null}

      <MemberModalArtistContent
        showArtistMembers={showArtistMembers}
        isGroupMode={isGroupMode}
        groupArtistSections={groupArtistSections}
        decidedSections={decidedSections}
        undecidedList={undecidedList}
        isAllMemberPartScope={isAllMemberPartScope}
        onArtistClick={onArtistClick}
        avatarStyle={avatarStyle}
        avatarInitial={avatarInitial}
        sectionClassName="member-modal__section"
        titleClassName="member-modal__section-title"
        listClassName="member-modal__list"
        rowClassName="member-modal__row"
        avatarClassName="member-modal__avatar"
        infoClassName="member-modal__info"
        nameClassName="member-modal__name"
        membershipClassName="member-modal__event-membership"
        badgesClassName="member-modal__badges"
        concertmasterBadgeClassName="member-modal__concertmaster-badge"
        chiefBadgeClassName="member-modal__chief-badge"
        roleBadgeClassName="member-modal__role-badge"
        emptyClassName="member-modal__empty"
        emptyText={artistEmptyText}
        hiddenText={artistHiddenText}
        groupShowMembership={groupShowMembership}
        groupShowBadges={groupShowBadges}
        groupIncludeCustomRoles={groupIncludeCustomRoles}
        groupSectionTitleBuilder={groupSectionTitleBuilder}
        renderGroupMemberTrailing={renderGroupMemberTrailing}
        renderArtistMemberTrailing={renderArtistMemberTrailing}
      />
    </>
  );
}
